<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
        {{ 'AddNameForThis' | translate}}
    </h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-center">
    <form #form="ngForm">
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100 m-b-10">
                <mat-label>{{ 'OrderName' | translate}}</mat-label>
                <input matInput placeholder="{{ 'OrderName' | translate}}" maxlength="50" name="orderName"
                    ngModel #orderName="ngModel" required />
            </mat-form-field>
        </div>
    </form>

    <div *ngIf="formErrors.length>0">
        <div *ngFor="let error of formErrors">
            <p class="validation-error">{{ error }}
            </p>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <mat-divider></mat-divider>
    <div class="col-md-12">
        <button class="btnConfirmation" (click)="Confirmation(form.value)">
            {{ 'confirmation' | translate}}
        </button>
        <button mat-button class="btnClose" (click)="onClose()"> {{ 'Back' | translate}}</button>
    </div>
</mat-dialog-actions>
